<template>
  <div class="p-2 bg-neutral-secondary rounded-md">
    <NText variant="caption1">
      {{ t('orders.flashTradingDescription') }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
